import { Plus } from 'lucide-react';

interface QuickActionCardProps {
  title: string;
  icon?: React.ReactNode;
  onClick?: () => void;
}

const QuickActionCard = ({ title, icon, onClick }: QuickActionCardProps) => {
  return (
    <div
      className="flex items-center justify-between px-4 py-3 border border-gray-200 rounded-xl bg-white hover:shadow-md transition cursor-pointer"
      onClick={onClick}
    >
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-lg bg-gray-100 flex items-center justify-center">{icon}</div>

        <span className="text-sm font-medium text-gray-700">{title}</span>
      </div>

      <Plus size={18} className="text-gray-500" />
    </div>
  );
};

export default QuickActionCard;
